import { Axios } from "@workspace/common";

import {
  BASE_CANDIDATES,
  BASE_CANDIDATE_CUSTOM_VIEW,
  BASE_CANDIDATE_STATIC_REPORT,
} from "./url_helper";

import { CANDIDATE_URL, JOB_URL } from "@workspace/common/src/config";

import { generateJobReportModuleURL, candidateModuleURL } from "./constant";

const { APIClient } = Axios;

const api = new APIClient();

// Create Custom View
export const createJobReportCustomView = (data) =>
  api.create(`${JOB_URL}${BASE_CANDIDATE_STATIC_REPORT}/customView/save`, data);

// Fetch JobReport Custom Views
export const getJobReportCustomViews = (viewType) =>
  api.get(
    `${JOB_URL}${BASE_CANDIDATE_STATIC_REPORT}/customView/all?viewType=${viewType}`
  );

// Select JobReport Custom View
export const selectJobReportCustomView = (id, viewType) =>
  api.put(
    `${JOB_URL}${BASE_CANDIDATE_STATIC_REPORT}/customView/update/${id}?viewType=${viewType}`
  );

// Delete JobReport Custom View
export const deleteJobReportCustomView = (id) =>
  api.delete(
    `${JOB_URL}${BASE_CANDIDATE_STATIC_REPORT}/customView/delete/${id}`
  );

// Get Custom View by id
export const getJobReportCustomViewById = (id) =>
  api.get(`${JOB_URL}${BASE_CANDIDATE_STATIC_REPORT}/customView/${id}`);

// Edit Custom View By id
export const editJobReportCustomViewById = (id, data) =>
  api.create(
    `${JOB_URL}${BASE_CANDIDATE_STATIC_REPORT}/customView/edit/${id}`,
    data
  );

// Unselect all candidate custom View
export const unSelectAllJobReportCustomView = (viewType) =>
  api.put(
    `${JOB_URL}${BASE_CANDIDATE_STATIC_REPORT}/customView/unselect-all?viewType=${viewType}`
  );

// Get job timeline count filter
export const getJobReportStaticReportCountFilter = (data) =>
  api.create(`${JOB_URL}${BASE_CANDIDATE_STATIC_REPORT}/get-counts`, data);

// Get Job Timeline listing
export const getJobReportStaticReportListing = (data) =>
  api.create(`${JOB_URL}${BASE_CANDIDATE_STATIC_REPORT}/listing`, data);

// Get job listing
export const getJobReportJobListing = (data) =>
  api.create(`${JOB_URL}${BASE_CANDIDATE_STATIC_REPORT}/listing/job`, data);

// Get job count filter
export const getJobReportJobCountFilter = (data) =>
  api.create(`${JOB_URL}${BASE_CANDIDATE_STATIC_REPORT}/get-counts/job`, data);
